module.exports = __webpack_public_path__ + "img/article-header-preview-1.cf75ffcd.jpg";